<template>
  <!-- 顶部联系信息栏 -->
  <!-- <div class="top-bar">
    <div class="container">
      <div class="contact-info">
        <div class="info-item">
          <el-icon><Phone /></el-icon>
          <span>0731-8882-6586</span>
        </div>
  
      </div>
    </div>
  </div> -->

  <!-- 主导航栏 -->
  <nav class="main-navigation full-width">
    <div class="nav-container content-center">
      <!-- Logo区域 -->
      <div class="nav-left">
        <router-link to="/" class="logo">
          <img src="@/assets/images/logo.png" alt="湖南美音" />
        </router-link>
        <div class="slogan">
          <h2>湖南美音</h2>
          <p>优质服务先行者</p>
        </div>
      </div>

      <!-- 导航菜单区域 -->
      <div class="nav-right">
        <div 
          v-for="item in navigationData" 
          :key="item.key"
          class="nav-item"
          @mouseenter="activeMenu = item.key"
          @mouseleave="activeMenu = null"
        >
          <router-link 
            :to="item.path"
            class="nav-title"
            :class="{ 'active': isActive(item.path) }"
          >
            {{ item.title }}
          </router-link>
          
          <transition name="fade">
            <div v-if="item.children && item.children.length > 0 && activeMenu === item.key" class="submenu">
              <router-link
                v-for="subItem in item.children"
                :key="subItem.key"
                :to="subItem.path"
                class="submenu-item"
                @click="handleSubMenuClick(subItem.path)"
              >
                <span class="submenu-title">{{ subItem.title }}</span>
              </router-link>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { navigationData } from '../../data/navigation';

const route = useRoute();
const router = useRouter();
const activeMenu = ref(null);

const isActive = (path) => {
  return route.path.startsWith(path);
};

// 处理子菜单点击
const handleSubMenuClick = (path) => {
  if (path.includes('#')) {
    // 如果是锚点链接
    const [routePath, hash] = path.split('#')
    if (route.path === routePath) {
      // 如果已经在当前页面，只处理锚点跳转
      const element = document.getElementById(hash)
      if (element) {
        const headerHeight = 80 // header 的高度
        const elementTop = element.offsetTop - headerHeight
        window.scrollTo({
          top: elementTop,
          behavior: 'smooth'
        })
      }
    } else {
      // 如果不在当前页面，先跳转页面再处理锚点
      router.push(path).then(() => {
        // 等待页面加载完成后再滚动到锚点位置
        setTimeout(() => {
          const element = document.getElementById(hash)
          if (element) {
            const headerHeight = 80
            const elementTop = element.offsetTop - headerHeight
            window.scrollTo({
              top: elementTop,
              behavior: 'smooth'
            })
          }
        }, 500) // 给页面一些加载时间
      })
    }
  } else {
    router.push(path)
  }
}

const handleNavClick = (path) => {
  if (path.includes('#')) {
    // 如果是锚点链接
    const [routePath, hash] = path.split('#');
    if (router.currentRoute.value.path === routePath) {
      // 如果已经在当前页面，只处理锚点跳转
      const element = document.getElementById(hash);
      if (element) {
        const headerHeight = 80; // header 的高度
        const elementTop = element.offsetTop - headerHeight;
        window.scrollTo({
          top: elementTop,
          behavior: 'smooth'
        });
      }
    } else {
      // 如果不在当前页面，先跳转页面再处理锚点
      router.push(path);
    }
  } else {
    // 如果是普通链接
    router.push(path);
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: 36px;
  background: #f5f7fa;
  border-bottom: 1px solid #eee;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001; // 确保在导航栏之上

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    height: 100%;
    display: flex;
    justify-content: flex-end; // 添加这行，使内容靠右对齐
  }

  .contact-info {
    display: flex;
    gap: 20px;

    .info-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #666;
      font-size: 14px;

      .el-icon {
        font-size: 16px;
        color: #2b5dff;
      }
    }
  }
}

.main-navigation {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 60px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  .nav-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
  }
}

.nav-left {
  display: flex;
  align-items: center;
  padding-left: 20px;

  .logo {
    display: block;
    height: 40px;
    margin-right: 15px;

    img {
      height: 100%;
      width: auto;
    }
  }

  .slogan {
    h2 {
      font-size: 18px;
      color: #333;
      margin: 0;
      line-height: 1.2;
    }

    p {
      font-size: 12px;
      color: #666;
      margin: 4px 0 0;
    }
  }
}

.nav-right {
  display: flex;
  align-items: center;
}

.nav-item {
  position: relative;
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;

  .nav-title {
    color: #333;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    transition: color 0.3s;

    &:hover, &.active {
      color: #1890ff;
    }
  }
}

.submenu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: fit-content;
  border-radius: 4px;
  padding: 8px 0;
  z-index: 1100;

  .submenu-item {
    display: block;
    padding: 12px 24px;
    text-decoration: none;
    color: #333;
    white-space: nowrap;
    font-size: 15px;
    
    &:hover {
      background: #f5f5f5;
    }

    .submenu-title {
      display: block;
      font-weight: 500;
      font-size: 15px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// 响应式样式调整
@media screen and (max-width: 768px) {
  .top-bar {
    display: none;
  }

  .main-navigation {
    top: 0;
    width: 100vw;
    max-width: 100vw;
    left: 0;
    right: 0;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    
    .nav-container {
      width: 100vw;
      max-width: 100vw;
      padding: 0;
      box-sizing: border-box;
      margin: 0;
    }
    
    .nav-left {
      padding-left: 0;
    }
    
    .nav-right {
      padding-right: 0;
    }
  }
}
</style>